import PropTypes from 'prop-types';
import { T as TooltipThemes, F as FormIntent, a as IconNames } from './types-6e7da022.js';

// This are the types of props we can pass to cx
const className = PropTypes.oneOfType([PropTypes.string, PropTypes.object]);
const children = PropTypes.any;
const reactComponent = PropTypes.oneOfType([PropTypes.element, PropTypes.node]);
const finalFormInputProps = PropTypes.shape({
  id: PropTypes.string,
  input: PropTypes.shape({
    checked: PropTypes.bool,
    name: PropTypes.string.isRequired,
    type: PropTypes.string
  })
});

// https://stackoverflow.com/questions/48007326/what-is-the-correct-proptype-for-a-ref-in-react/51127130#51127130
const forwardedRef = PropTypes.oneOfType([
// Either a function
PropTypes.func,
// Or the instance of a DOM native element (see the note about SSR)
PropTypes.shape({
  current: PropTypes.elementType
})]);
const damageMeta = PropTypes.shape({
  overlayUrl: PropTypes.string,
  side: PropTypes.string,
  size: PropTypes.string,
  x: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  y: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});
const inputConfig = {
  className,
  feedbackTooltip: PropTypes.shape({
    content: children,
    fillWidth: PropTypes.bool,
    isTabletMobile: PropTypes.bool,
    placement: PropTypes.string,
    placementFlipped: PropTypes.string,
    theme: PropTypes.oneOf(Object.values(TooltipThemes)),
    tooltipIcon: PropTypes.element
  }),
  innerClassName: className,
  inputFocused: PropTypes.bool,
  inputProps: finalFormInputProps.isRequired,
  intent: PropTypes.oneOf(Object.values(FormIntent)),
  label: children,
  labelProps: PropTypes.objectOf(PropTypes.node),
  large: PropTypes.bool,
  leftIconName: PropTypes.string,
  money: PropTypes.bool,
  noIcon: PropTypes.bool,
  onClickIcon: PropTypes.func,
  onLeftIconClick: PropTypes.func,
  optionalLabel: children,
  renderInput: PropTypes.func,
  rightIconName: PropTypes.oneOf(Object.values(IconNames)),
  vrm: PropTypes.bool
};
const input = PropTypes.shape(inputConfig);
const inputProps = PropTypes.shape({
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onMouseOver: PropTypes.func,
  value: PropTypes.string
});
var commonPropTypes = {
  children,
  className,
  damageMeta,
  finalFormInputProps,
  forwardedRef,
  input,
  inputConfig,
  inputProps,
  reactComponent
};

export { commonPropTypes as c };
